import React, { useEffect, useState } from "react";

export default function useTimer() {
  const [timer, setTimer] = useState(0);
  useEffect(() => {
    const timerRef = setInterval(() => {
      setTimer((time) => time + 1);
    }, 1000);
    return () => {
      clearInterval(timerRef);
    };
  }, []);
  return (
    <span className="digit">
      {`${Math.floor((timer / 60) % 60)
        .toString()
        .padStart(2, "0")}:${Math.floor(timer % 60)
        .toString()
        .padStart(2, "0")}
      `}
    </span>
  );
}
